export function deltaToDayName(delta, t, lang) {
  if (delta === null || delta === undefined) return t('clima.soon');
  if (delta === 0) return t('clima.today');
  if (delta === 1) return t('clima.tomorrow');
  const d = new Date();
  d.setDate(d.getDate() + delta);
  return d.toLocaleDateString(lang, { weekday: 'long' });
}

export function formatVentanas(ventanas, t, lang) {
  if (!ventanas || ventanas.length === 0) return t('clima.soon');
  const dias = ventanas.slice(0, 3).map(v => deltaToDayName(v.delta, t, lang));
  if (dias.length === 1) return dias[0];
  if (dias.length === 2) return `${dias[0]} ${t('clima.and')} ${dias[1]}`;
  return `${dias[0]}, ${dias[1]} ${t('clima.and')} ${dias[2]}`;
}

export function renderSug(sug, t, lang) {
  if (!sug.clave) return { msg: sug.mensaje, det: sug.detalle };
  const p = sug.params || {};
  const tParams = { ...p };
  if (p.dia_delta !== undefined) tParams.dia = deltaToDayName(p.dia_delta, t, lang);
  if (p.ventanas) tParams.dias_str = formatVentanas(p.ventanas, t, lang);
  if (p.ventanas && p.ventanas.length > 0 && tParams.dia === undefined) {
    tParams.dia = deltaToDayName(p.ventanas[0].delta, t, lang);
  }
  const msg = t('sugerencias.' + sug.clave + '.msg', { ...tParams, defaultValue: sug.mensaje });
  const det = t('sugerencias.' + sug.clave + '.det', { ...tParams, defaultValue: sug.detalle });
  return { msg, det };
}
